module.exports = __webpack_public_path__ + "img/enroll_course.8939640e.png";